import React from "react";
import ct from "class-types.macro";
import ChatLink from "./ChatLink";
import { VariantProps } from ".";
import Standard from "../Price";

const I = ({ selectedProduct, productListingView }: VariantProps) => {
  const { unitOfMeasure, price } = selectedProduct;

  return (
    <div className="map map-override mapI">
      <Standard price={price.price} unitOfMeasure={unitOfMeasure} />
      <p
        className={ct(
          "font-semibold",
          "text-xs",
          "leading-none",
          "mb-2",
          "text-gray-800",
          productListingView === "list"
            ? ct("mt-1", "p-0", "pb-1", "xs:m-0", "xs:text-center")
            : ct("p-0", "pt-1", "text-center"),
        )}
        data-testid="maptext"
      >
        <>
          Contact us for details
          <ChatLink productListingView={productListingView} />
        </>
      </p>
    </div>
  );
};

export default I;
